<template>
  <div>
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="notice-detail ccui-app-container-detail">
      <div class="ccui-app-container-detail-body dic-ccui-form-biserial">
        <div class="notice-title">{{ schemeObj.schemeName }}</div>
        <el-form>
          <el-row>
            <el-form-item label="项目编号：">{{
              schemeObj.schemeCode
            }}</el-form-item>
            <el-form-item label="发布时间：">{{
              schemeObj.noticeStartTime
            }}</el-form-item>
            <el-form-item label="发布单位：">{{
              schemeObj.opUnitName
            }}</el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="template-detail-body ccui-clearfix">
      <div class="detail-box">
        <!--左侧内容-->
        <div class="detail-info">
          <div class="ccui-app-container-detail">
            <div class="ccui-app-container-detail-body  dic-ccui-form-biserial">
              <div class="notice-detail-title">公告</div>
              <el-form>
                <el-row>
                  <el-form-item label="公告标题：">{{
                    pageData.noticeTitle
                  }}</el-form-item>
                  <el-form-item label="公告内容：">
                    <div v-html="pageData.textInfo"></div>
                  </el-form-item>
                </el-row>
              </el-form>

              <div class="notice-detail-title">附件列表</div>
              <detailTable
                :tableData="pageData.fileinfoBOS"
                :tableHead="fileHead"
                :showIndex="true"
              ></detailTable>

              <!--包件信息-->
              <template v-for="(item, index) in packageList">
                <div :key="index">
                  <template v-if="subPackageFlag === '1'">
                    <div class="notice-detail-title">{{ item.packName }}</div>
                    <el-form>
                      <el-row>
                        <el-form-item label="包件说明：">暂无</el-form-item>
                      </el-row>
                    </el-form>
                  </template>
                  <div class="notice-detail-title" v-else></div>
                  <el-group-title title="物资信息"></el-group-title>
                  <detailTable
                    :tableData="item.matDetailList"
                    :tableHead="packageHead"
                    :showIndex="true"
                  ></detailTable>
                </div>
              </template>

              <div class="notice-detail-title">相关公告列表</div>
              <detailTable
                :tableData="otherNoticeList"
                :tableHead="noticeHead"
                :showIndex="true"
              ></detailTable>
            </div>
          </div>
        </div>

        <!--右侧内容-->
        <div class="detail-info-right fl">
          <div class="notice-detail-box-in">
            <div class="company-name-title">
              中交一公局集团有限公司总承包经营分公司
            </div>
            <el-divider></el-divider>
            <div class="color-1">采购金额</div>
            <div><span class="purchase-money ccui-mr-10">109.26</span>万元</div>
            <div class="color-1 pt15">
              累计采购项目<span class="pl20 pr-5">123424</span>单
            </div>
          </div>
        </div>
        <div class="color-1 fl ml20 mt10">该单位还在采购</div>
        <div class="detail-info-right fl mt10">
          <div class="notice-detail-box-in">
            <div class="purchase-class materials">物资采购</div>
            <div class="scheme-name ell-2">
              中交一公局第五中交一公局第五工程有限公司盐城市啊适当
            </div>
            <div class="class-name ell color-1">钢材/钢板/型材</div>
            <div class="ccui-clearfix pt15">
              <span class="fl color-1">发布时间：</span>
              <span class="fr">2019-10-19 10:30</span>
            </div>
            <div class="ccui-clearfix pt5">
              <span class="fl color-1">采购数量：</span>
              <span class="fr">123</span>
            </div>
            <div class="dotted-line"></div>
            <div class="color-1">
              <i class="el-icon-time notice-icon-time"></i>距离结束1天
            </div>
            <div class="dotted-line"></div>
            <div class="color-1">中交一公局第五工程有限公司</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import {
  qryNoticeDetail,
  queryProcessSchemeMatDetail,
  qryNoticeList
} from "@/app/shop/api/shopping";
export default {
  name: "noticeDetail",
  components: {
    baseBreadCrumb,
    detailTable
  },
  data() {
    return {
      currBreadCrumb: [{ title: "采购公告" }, { title: "" }],
      fileHead: [
        { label: "附件名称", prop: "fileName" },
        { label: "附件说明", prop: "fileDesc" },
        { label: "操作", slot: "opp", align: "center" }
      ],
      packageHead: [
        { label: "设备物资名称", prop: "matName" },
        { label: "设备物资说明", prop: "matDesc" },
        { label: "数量", prop: "convNum" },
        { label: "单位", prop: "convMeasureUnitName" }
      ],
      noticeHead: [
        { label: "类型", prop: "purStep", width: 80 },
        { label: "标题", prop: "noticeTitle" },
        { label: "环节", prop: "purStep", width: 80 },
        {
          label: "发布时间",
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      pageData: {},
      otherNoticeList: [],
      schemeObj: {
        opUnitName: this.$route.query.opUnitName
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId,
        purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data;
          this.currBreadCrumb[1].title = this.pageData.noticeTitle;
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
        }
      });
      //查询包件信息
      queryProcessSchemeMatDetail({
        schemeId: this.$route.query.schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.subPackageFlag = res.data.data.subPackageFlag;
          if (this.subPackageFlag === "0") {
            this.packageList = [{ matDetailList: res.data.data.matDetailList }];
          } else {
            this.packageList = res.data.data.packageList;
          }
          this.schemeObj.schemeName = this.packageList[0].matDetailList[0].schemeName;
          this.schemeObj.schemeCode = this.packageList[0].matDetailList[0].schemeCode;
        }
      });
      //查询相关公告列表
      qryNoticeList({
        schemeId: this.$route.query.schemeId,
        supCode: JSON.parse(sessionStorage.getItem("supInfo")).supCode
      }).then(res => {
        if (res.data.code === "0") {
          this.otherNoticeList = res.data.data.rows;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
